import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "besidaMob-send.icon",
  "use": "besidaMob-send.icon-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 16\" id=\"besidaMob-send.icon\"><path d=\"M2.176 13.832L4.592 9h7.853l-10.27 4.832zm0-11.664L12.445 7H4.592L2.176 2.168zM15.7 6.321L2.65.181A1.835 1.835 0 0 0 .532.562 1.835 1.835 0 0 0 .2 2.688L2.856 8 .2 13.311a1.835 1.835 0 0 0 .332 2.126 1.832 1.832 0 0 0 2.118.383L15.7 9.68A1.839 1.839 0 0 0 16.766 8c0-.727-.408-1.369-1.066-1.679z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol